import { render } from "./ProjectImageModal.vue?vue&type=template&id=5f23b340&scoped=true&ts=true"
import script from "./ProjectImageModal.ts?vue&type=script&lang=ts"
export * from "./ProjectImageModal.ts?vue&type=script&lang=ts"

import "./ProjectImageModal.scss?vue&type=style&index=0&id=5f23b340&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f23b340"]])

export default __exports__